/* eslint-disable */
import React, { useEffect } from "react";
import { Button, Form, Input, message } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import "../D5Login/index.css";
import { TriggerEmailApi, VerifyEmailApi } from "../../api/Api";

function VerifyPage() {
	const navigate = useNavigate();
	const { state } = useLocation();
	const [form] = Form.useForm();

	useEffect(() => {
		if (state?.email) {
			form.setFieldValue("email", state?.email);
		}
	}, [state]);

	const handleSubmit = async (values: any) => {
		try {
			const res = await VerifyEmailApi({
				code: values?.code,
				email: values?.email,
			});
			if (res) {
				message.success("Verification success");
				navigate("/login");
			}
		} catch (e: any) {
			message.error(e?.message);
		}
	};

	const handleSendCode = async () => {
		const email = form.getFieldValue("email");
		if (!email || email == "") {
			message.error("请输入 Email");
			return;
		}
		try {
			const res = await TriggerEmailApi({
				email: email,
			});
			if (res) {
				message.success("Verification code sent");
			}
		} catch (e: any) {
			message.error(e?.message ?? e?.toString());
		}
	};

	const onFinishFailed = (errorInfo: any) => {
		console.log("Failed:", errorInfo);
	};

	return (
		<div className="login-wrapper">
			<div className="glow-bg-2"></div>
			<div className="login-wrapper-main">
				<div className="login-left">
					<div className="login-left-title-wrapper">
						<video
							width="100%"
							controls
							autoPlay
							muted
							style={{ border: "none", outline: "none", borderRadius: "10px" }}
						>
							<source src="../../demo.mp4" type="video/mp4" />
							Your browser does not support the video tag.
						</video>
					</div>
				</div>
				<div className="dlp">
					<div className="login-card-wrapper">
						<div className="login-card-header">
							<div className="login-card-title">验证账户</div>
							<div className="login-card-subtitle">
								欢迎加入杭州五维数据有限责任公司
							</div>
						</div>
						<Form
							name="basic"
							form={form}
							layout="vertical"
							initialValues={{ remember: true }}
							onFinish={handleSubmit}
							onFinishFailed={onFinishFailed}
							autoComplete="off"
						>
							<Form.Item
								label="邮箱"
								name="email"
								rules={[
									{ required: true, message: "Please input your email!" },
								]}
							>
								<Input style={{ height: "40px", width: "95%" }} />
							</Form.Item>

							<Form.Item
								label="验证码"
								name="code"
								rules={[
									{
										required: true,
										message: "Please input verification code!",
									},
								]}
							>
								<Input style={{ height: "40px", width: "95%" }} />
							</Form.Item>

							<div className="login-more">
								<span onClick={handleSendCode} style={{ cursor: "pointer" }}>
									重新发送验证码
								</span>
							</div>

							<Form.Item
								label={null}
								style={{ textAlign: "center", marginTop: 30 }}
							>
								<Button
									type="primary"
									htmlType="submit"
									style={{
										width: "80%",
										borderRadius: 10,
										padding: 20,
										fontSize: 17,
										margin: "0 auto 40px 0",
									}}
								>
									确认
								</Button>
							</Form.Item>
						</Form>
					</div>
				</div>
			</div>
		</div>
	);
}

export default VerifyPage;
